import clsx from "clsx";
import { Icon, Sheet } from "@cntrl/ui";
import type { components } from "@cntrl/api-client";
import { mobileNavIcon } from "../mobile/mobileTabs.js";
import styles from "../mobile/MobileShell.module.scss";

type MobileMoreRow = components["schemas"]["MobileMoreRow"];

export interface RosterMoreSheetProps {
  /** The org More rows from the server nav document (`nav.mobile.more`) — Finances (teaser) + Settings. */
  rows: MobileMoreRow[];
  /** Kept MOUNTED and toggled by this so opening is instant (the band More sheet's warm-mount shape). */
  open: boolean;
  /** Open the org Settings — the routed `/roster/settings` page (the modal is desktop-only chrome). */
  onOpenSettings: () => void;
  onClose: () => void;
}

/**
 * The roster's mobile More sheet (ART-155). Same server rows as the band More sheet, but the actionable one —
 * Settings — routes to `/roster/settings` (the org settings PAGE), not the band `/settings`, so it cannot
 * reuse `MoreSheet`'s band key→route map. Finances stays a disabled "Q3 2026" teaser exactly as it does on
 * the band shell.
 */
export function RosterMoreSheet({ rows, open, onOpenSettings, onClose }: RosterMoreSheetProps) {
  return (
    <Sheet title="More" open={open} onClose={onClose} closeLabel="Close More menu">
      <ul className={styles.sheetList}>
        {rows.map((row) => {
          const key = row.key ?? "";
          const Glyph = mobileNavIcon(key);
          const comingSoon = row.comingSoon ?? undefined;
          return (
            <li key={key}>
              <button
                type="button"
                className={clsx(styles.sheetRow, comingSoon && styles.sheetRowDisabled)}
                disabled={comingSoon !== undefined}
                onClick={() => {
                  if (comingSoon) return;
                  if (key === "settings") onOpenSettings();
                  onClose();
                }}
              >
                <Icon icon={Glyph} size={20} />
                <span className={styles.sheetRowBody}>
                  <span className={styles.sheetRowLabel}>{row.label}</span>
                </span>
                {comingSoon && <span className={styles.sheetBadge}>{comingSoon}</span>}
              </button>
            </li>
          );
        })}
      </ul>
    </Sheet>
  );
}
